import { Title } from "#/services/page-title/Title"
import React from "react"
import { useIntl } from "react-intl"

export function RoutingFlowTitle({ title }: { title: string }): JSX.Element {
  const intl = useIntl()
  return <Title {...{ title }} productTitle={intl.formatMessage({ defaultMessage: "Create Carrot Plan" })} />
}
